/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateAppointmentExchangeRequest
 */
export interface CreateAppointmentExchangeRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentExchangeRequest
     */
    appointmentId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateAppointmentExchangeRequest
     */
    requestedPurposeKeys: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateAppointmentExchangeRequest
     */
    note: string | null;
}

/**
 * Check if a given object implements the CreateAppointmentExchangeRequest interface.
 */
export function instanceOfCreateAppointmentExchangeRequest(value: object): value is CreateAppointmentExchangeRequest {
    if (!('appointmentId' in value) || value['appointmentId'] === undefined) return false;
    if (!('requestedPurposeKeys' in value) || value['requestedPurposeKeys'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function CreateAppointmentExchangeRequestFromJSON(json: any): CreateAppointmentExchangeRequest {
    return CreateAppointmentExchangeRequestFromJSONTyped(json, false);
}

export function CreateAppointmentExchangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAppointmentExchangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentId': json['appointmentId'],
        'requestedPurposeKeys': json['requestedPurposeKeys'],
        'note': json['note'],
    };
}

export function CreateAppointmentExchangeRequestToJSON(json: any): CreateAppointmentExchangeRequest {
    return CreateAppointmentExchangeRequestToJSONTyped(json, false);
}

export function CreateAppointmentExchangeRequestToJSONTyped(value?: CreateAppointmentExchangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentId': value['appointmentId'],
        'requestedPurposeKeys': value['requestedPurposeKeys'],
        'note': value['note'],
    };
}

